import { translate } from './translate';
import { hasSubdivisionOrZipCodeShippingError } from './calculationError.utils';
export function getShippingMethods(checkout, translations) {
  var _checkout$shippingInf, _checkout$shippingInf2;
  if (hasSubdivisionOrZipCodeShippingError(checkout)) {
    return;
  }
  const options = ((_checkout$shippingInf = checkout.shippingInfo) == null ? void 0 : (_checkout$shippingInf2 = _checkout$shippingInf.carrierServiceOptions) == null ? void 0 : _checkout$shippingInf2.flatMap(_ref => {
    let {
      shippingOptions
    } = _ref;
    return shippingOptions;
  })) || [];
  return options.map(_ref2 => {
    var _cost$price$amount, _cost$price, _logistics$pickupDeta;
    let {
      title,
      cost,
      code,
      logistics
    } = _ref2;
    return {
      label: title,
      amount: (_cost$price$amount = cost == null ? void 0 : (_cost$price = cost.price) == null ? void 0 : _cost$price.amount) != null ? _cost$price$amount : '0',
      identifier: code,
      detail: (logistics == null ? void 0 : logistics.deliveryTime) || translate(translations, 'cart.delivery_method_picker.pickup_address', toOptions(logistics == null ? void 0 : (_logistics$pickupDeta = logistics.pickupDetails) == null ? void 0 : _logistics$pickupDeta.address))
    };
  });
}
function toOptions(address) {
  if (!address) {
    return {};
  }
  const {
    countryFullname,
    subdivisionFullname,
    addressLine,
    city
  } = address;
  return {
    country: countryFullname,
    subdivision: subdivisionFullname,
    addressLine: addressLine,
    city: city
  };
}
//# sourceMappingURL=getShippingMethods.js.map